import { apiClient } from '@/shared/api/client.js';

export interface MyFollowsResponse {
  authors: string[];
  genres: string[];
}

export const followsApi = {
  async list(): Promise<MyFollowsResponse> {
    const { data } = await apiClient.get<MyFollowsResponse>('/me/follows');
    return data;
  },

  async followAuthor(author: string): Promise<void> {
    await apiClient.post('/me/follows/authors', { author });
  },

  async unfollowAuthor(author: string): Promise<void> {
    await apiClient.delete(`/me/follows/authors/${encodeURIComponent(author)}`);
  },

  async followGenre(genre: string): Promise<void> {
    await apiClient.post('/me/follows/genres', { genre });
  },

  async unfollowGenre(genre: string): Promise<void> {
    await apiClient.delete(`/me/follows/genres/${encodeURIComponent(genre)}`);
  },
};
